module.exports = __webpack_public_path__ + "img/logo_medcomid.ad04fb6f.png";